module.exports = __webpack_public_path__ + "img/hr-water-green-side.88c18c75.png";